(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('projectDetails', projectDetails);

	projectDetails.$inject = ['$rootScope', '$scope', '$state', '$timeout', 'editProjectService', 'a3ModalService'];

	function projectDetails($rootScope, $scope, $state, $timeout, editProjectService, a3ModalService) {
		var vm = this;
		vm.loading = false;
		vm.empty = true;
		vm.project = {};
		vm.dirFactoryNdx = globalConfig.factory.id;

		vm.loadProjectDetail = loadProjectDetail;
		vm.openA3 = openA3;
		vm.goToProjectPage = goToProjectPage;

		function loadProjectDetail(projectIndex, factoryNdx) {
			if (!factoryNdx) {
				factoryNdx = globalConfig.factory.id; 
			}
			vm.project = {};
			vm.loading = true;
			editProjectService.getDetails(projectIndex, factoryNdx).then(function (response) {
				vm.project = response.data.project;

				vm.project.targetSavings = vm.project.targetSavingsAnnual + vm.project.targetSavingsCostAvoidance +
					vm.project.targetSavingsOneTime;
				vm.project.actualSavings = vm.project.actualSavingsAnnual + vm.project.actualSavingsCostAvoidance +
					vm.project.actualSavingsOneTime - vm.project.implementationCost;
				vm.project.categoryStrings = '';
				if (_.has(vm.project, 'categories') && vm.project.categories.length > 0) {
					var categoryLength = vm.project.categories.length;
					for (var i = 0; i < categoryLength; i++) {
						vm.project.categoryStrings += vm.project.categories[i].name;
						if (i < categoryLength - 1) {
							vm.project.categoryStrings += ', ';
						}
					}
				}
				vm.loading = false;
				vm.empty = false;
			});

		}

		function openA3(projNdx) {
			var modalInstance = a3ModalService.openModal(projNdx, vm.project.leanDirFactoryNdx);
			
			modalInstance.result.finally(function() {
				a3ModalService.removeNoPrintClass();
			});			
		}

		function goToProjectPage() {
			$state.go('app.lean-projects.edit-project', {
				projectNdx: vm.project.id,
				factoryNdx: vm.project.leanDirFactoryNdx
			});
		}
	}
})();